import React from "react";
import { IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useKivunovaTranslation } from "@kivunova/kivufrontendcommon";

interface PasswordVisibilityAdornmentProps {
  isVisible: boolean;
  onToggle: () => void;
  disabled?: boolean;
}

const passwordIconSx = {
  color: "grey.400",
  transition: "color 0.2s ease",
  "&:hover": { color: "grey.600" },
  ".Mui-focused &": { color: "primary.main" }
};

const PasswordVisibilityAdornment: React.FC<
  PasswordVisibilityAdornmentProps
> = ({ isVisible, onToggle, disabled = false }) => {
  const { t } = useKivunovaTranslation();

  return (
    <InputAdornment position="end">
      <IconButton
        aria-label={
          isVisible
            ? t("hide-password", "Hide password")
            : t("show-password", "Show password")
        }
        onClick={onToggle}
        onMouseDown={(e) => e.preventDefault()}
        edge="end"
        disabled={disabled}
        sx={passwordIconSx}
      >
        {isVisible ? (
          <VisibilityOff fontSize="small" />
        ) : (
          <Visibility fontSize="small" />
        )}
      </IconButton>
    </InputAdornment>
  );
};

export default PasswordVisibilityAdornment;
